// =============================================================================
//  Copyright : 2021 semantics GmbH
//  Date      : $Date: 2021-10-29 17:11:09 +0200 (Fri, 29 Oct 2021) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 122966 $
//  Purpose   : rules for state nodes
// =============================================================================
// ---Third-party imports

// ---Framework imports
import {has, sorted, get, keys, flatten} from 'ldash'
import {Actions} from 'uix/registries'
import log from 'uix/logging'

// ---Local imports
import {NTYPE} from './const'
import {ID, dummyChildren} from '../utils'

// ---Globals

export const DOMAIN_BYTYPE = ({
  domains,
  loadedDomains,
  buildStaticDomainNode,
  isVlmEnabled,
  treeAvailableTypes,
}) => ({
  buildAfter: NTYPE.DOMAIN,
  isEnabled: node => isVlmEnabled('bytype', node.dname, domains, loadedDomains),
  buildNodes: flatNodes =>
    flatNodes[NTYPE.DOMAIN].map(dnode =>
      buildStaticDomainNode(NTYPE.DOMAIN_BYTYPE, dnode, 'Typen', has(treeAvailableTypes, dnode.id))
    ),
  getChildren: node => Actions.getAvailableTypes(node.dname),
})

export const BYTYPE_TYPE = ({domains, i18n, loadedDomains, treeChildData, treeAvailableTypes}) => ({
  buildAfter: NTYPE.DOMAIN_BYTYPE,
  isEnabled: node => !domains.data[node.dname].isGhost,
  buildNodes: flatNodes => {
    let datatype = 1
    return flatten(
      flatNodes[NTYPE.DOMAIN_BYTYPE].map(node => {
        let {dname, id: parentId} = node
        if (!loadedDomains[dname]) {
          return []
        }
        let availableInfo = get(treeAvailableTypes, dname, {})
        let types = loadedDomains[dname].types
        let mdtypes = keys(types.metadata)
        let di18n = loadedDomains[dname].i18n[i18n._language]
        let mdNodes = mdtypes.map(name => {
          let id = ID(parentId, name)
          let loaded = Boolean(get(treeChildData, `${id}.0`))
          let children = undefined
          if (!loaded && availableInfo[name] === true) {
            children = dummyChildren
          }
          return {
            nodeType: NTYPE.BYTYPE_TYPE,
            id,
            idContext: id,
            parentId,
            odid: node.odid,
            title: i18n.getType(datatype, types.byName[name].internalType),
            dname: node.dname,
            typeName: name,
            loaded,
            children,
          }
        })
        mdNodes = sorted(mdNodes, node => node.title)
        return mdNodes
      })
    )
  },
  getChildren: node =>
    Actions.getChildren({typeName: node.typeName, odid: node.odid, idContext: node.idContext}),
})
